<template>
  <AppHeaderDropdown
    right
    no-caret
  >
    <template slot="header">
      {{ $store.state.NAME === 'UNKNOWN' ? '로그인' : $store.state.NAME }}
      <img
        :src="$store.getters.profile"
        class="img-avatar"
        :alt="$store.state.EMAIL"
      >
    </template>
    <template slot="dropdown">
      <b-dropdown-item
        v-if="$store.state.NAME === 'UNKNOWN'"
        @click="$router.push('/pages/login')"
      >
        <i class="fa fa-lock" /> 로그인
      </b-dropdown-item>
      <b-dropdown-item
        v-if="$store.state.NAME !== 'UNKNOWN'"
        @click="logout"
      >
        <i class="fa fa-lock" /> 로그아웃
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout () {
      this.$store.commit('clearAll')
      this.$router.push('/dashboard')
    }
  }
}
</script>
